import React, { useEffect, useState } from 'react';
import { UpdateServico } from '@services/Servico/Index.jsx';
import SweetAlert from '@components/Feedback/SweetAlert/Index.jsx';
import ButtonComp from '@components/UI/Button/Index.jsx';
import ValidationsServico from '@validations/Servico/Validations.jsx';
import InputTextModalComp from '@components/UI/InputTextModal/Index.jsx';
import SelectOptionModalComp from '@components/UI/SelectOptionModal/Index.jsx';
import { flgStatusOptions } from '@enums/FlgStatus/Index';
import { Modal } from 'antd';
import { flagAuditoriaOptions } from '@enums/FlagAuditoria/Index';

function EditModal({ onUpdate, visible, closeModal, selectedRow }) {
  const [codigo, setCodigo] = useState('');
  const [tempValues, setTempValues] = useState({
    ano: '',
    servico: '',
    descricao: '',
    flagAuditoria: null,
    flgStatus: null,
  });

  useEffect(() => {
    if (selectedRow) {
      const initialValues = {
        ano: selectedRow.ano,
        servico: selectedRow.servico,
        descricao: selectedRow.descricao,
        flagAuditoria: selectedRow.flagAuditoria,
        flgStatus: selectedRow.flgStatus,
      };
      setCodigo(selectedRow.codigo);
      setTempValues(initialValues);
    }
  }, [selectedRow]);

  const checkIsDirty = () => {
    return (
      selectedRow.ano !== tempValues.ano ||
      selectedRow.servico !== tempValues.servico ||
      selectedRow.descricao !== tempValues.descricao ||
      selectedRow.flgStatus !== tempValues.flgStatus
    );
  };

  const onSubmit = async () => {
    try {
      if (!checkIsDirty()) {
        SweetAlert.error("Erro", "Nenhuma alteração foi feita nos dados.");
        return;
      }

      const { validateFields } = ValidationsServico();

      const errors = validateFields({
        ...tempValues,
      });

      if (Object.keys(errors).length > 0) {
        const errorMessage = Object.values(errors).join("\n");
        SweetAlert.error("Erro na Validação", errorMessage);
        return;
      }

      const payload = {
        ano: parseInt(tempValues.ano, 10),
        servico: tempValues.servico,
        descricao: tempValues.descricao,
        flgStatus: tempValues.flgStatus,
      };

      SweetAlert.loading();

      const result = await UpdateServico(selectedRow.id, payload);

      onUpdate({ ...result });

      closeModal();

      SweetAlert.success('Atualização Concluída!', 'Os dados foram atualizados com sucesso.');
    } catch (error) {

      const errorMessage = error.parsed?.message || 'Não foi possível atualizar o serviço.';

      SweetAlert.errorHTML('Erro ao atualizar', errorMessage);
      console.error("Erro ao salvar atualizações", errorMessage);
    }
  };

  const handleTempChange = (field, value) => {
    setTempValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCloseWithReset = () => {
    if (selectedRow) {
      setTempValues({
        ano: selectedRow.ano,
        servico: selectedRow.servico,
        descricao: selectedRow.descricao,
        flagAuditoria: selectedRow.flagAuditoria,
        flgStatus: selectedRow.flgStatus,
      });
    };
    closeModal();
  };

  return (
    <Modal
      getContainer={false}
      open={visible}
      onCancel={handleCloseWithReset}
      centered
      footer={null}
      width={800}
      title={<h5 className="fw-bold">Edição de Serviço</h5>}
    >
      <hr />

      <InputTextModalComp
        label="Código"
        value={codigo}
        placeholder="Código"
        hoverMessage={"Código disponível apenas para visualização."}
        disabled
      />

      <InputTextModalComp
        label={"Ano"}
        value={tempValues.ano}
        onChange={(e) => handleTempChange('ano', e.target.value)}
        placeholder={"Digite um Ano"}
        hoverMessage={"Preencher um ano com caracteres exclusivamente numéricos."}
        maxLength={4}
        pattern="\d{4}"
        disabled
      />

      <InputTextModalComp
        label={"Serviço"}
        value={tempValues.servico}
        onChange={(e) => handleTempChange('servico', e.target.value)}
        placeholder={"Digite um serviço"}
        hoverMessage={"Preencher com um Serviço."}
        maxLength={255}
        disabled
      />

      <SelectOptionModalComp
        label={"É uma auditoria?"}
        options={flagAuditoriaOptions}
        value={flagAuditoriaOptions.find(option => option.value === tempValues.flagAuditoria)}
        onChange={(option) => handleTempChange('flagAuditoria', option.value)}
        placeholder={"Selecionar uma opção"}
        hoverMessage={"Selecionar uma opção"}
        isDisabled
      />

      <InputTextModalComp
        label={"Descrição"}
        value={tempValues.descricao}
        onChange={(e) => handleTempChange('descricao', e.target.value)}
        placeholder={"Digite uma descrição"}
        hoverMessage={"Preencher com uma Descrição do Serviço."}
        maxLength={255}
      />

      <SelectOptionModalComp
        label={"Status"}
        options={flgStatusOptions}
        value={flgStatusOptions.find(option => option.value === tempValues.flgStatus)}
        onChange={(option) => handleTempChange('flgStatus', option.value)}
        placeholder={"Selecionar o status"}
        hoverMessage={"Selecionar o status"}
      />

      <div className="d-flex justify-content-end gap-2 mt-4">
        <ButtonComp
          title="ATUALIZAR"
          buttonColor="#2b97be"
          classnameIcon="fa-regular fa-floppy-disk"
          onClick={onSubmit}
          hoverMessage={"Botão para confirmar a atualização"}
        />
        <ButtonComp
          title="CANCELAR"
          buttonColor="#dc3545"
          classnameIcon="fa-regular fa-circle-xmark"
          onClick={handleCloseWithReset}
          hoverMessage={"Botão para cancelar a atualização"}
        />
      </div>
    </Modal>
  );
}

export default EditModal;
